import React from "react";

const Card = ({ as: As = "div", className = "", padded = true, children, ...rest }) => {
    return (
        <As
            className={`rounded-2xl bg-white shadow-card border border-ink-100 ${
                padded ? "p-4 sm:p-6" : ""
            } ${className}`}
            {...rest}
        >
            {children}
        </As>
    );
};

export default Card;
